<template>
  <div class="ui-no-works" v-show="showNoWorksData">
    <div class="bg"></div>
    <p class="text">{{ noDataText }}</p>
  </div>
</template>

<script>
export default {
  name: "uiNoWorks",
  props: {
    showNoWorksData: {
      type: Boolean,
      default: true
    },
    noDataText: {
      type: String,
      default: "暂无数据"
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-no-works {
  display: flex;
  flex-direction: column;
  align-items: center;
  .bg {
    background: url("../../assets/images/common_graphy_nowork@2x.png") no-repeat center;
    background-size: 100% 100%;
    width: 1.8rem;
    height: 1.8rem;
    margin-top: 1.2rem;
    margin-bottom: 0.1rem;
  }
  .text {
    font-family: PingFangSC-Regular;
    font-size: 0.32rem;
    color: #999999;
    letter-spacing: 0;
    text-align: center;
  }
}
</style>
